import { apiCall } from "../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint) => apiCall("delete", endpoint);

export const getVendorStagesApi = async () => {
  try {
    return await get("get_vendor_stage");
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getVendorListApi = async (params) => {
  try {
    return await get("vendor", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getProjectListApi = async (params) => {
  try {
    return await get("vendor/project/list", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getProductListApi = async (params) => {
  try {
    return await get("vendor/product/list", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const updateStageApi = async (id, bodyData) => {
  try {
    return await put(`vendor/stage_update/${id}`, bodyData);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const updateStatusApi = async (id, bodyData) => {
  try {
    return await put(`vendor/status_update/${id}`, bodyData);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const deleteVendorApi = async (id) => {
  try {
    return await del(`vendor/delete/${id}`);
  } catch (err) {
    return err.response;
  }
};

//view vendor details
export const getVendorDetailsApi = async (id) => {
  try {
    return await get(`vendor/view/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getContactListApi = async (vendorId, params) => {
  try {
    return await get(`vendor/contact/${vendorId}`, params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getProductLdistApi = async (params) => {
  try {
    return await get("products", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const deleteContactApi = async (id) => {
  try {
    return await del(`vendor/contact/${id}`);
  } catch (err) {
    return err.response;
  }
};
export const getRequestListApi = async (params) => {
  try {
    return await get("purchase_request", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const submitContactAPI = async (vendorId, body) => {
  try {
    return await post(`vendor/contact/${vendorId}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateContactAPI = async (id, body) => {
  try {
    return await put(`vendor/contact/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const downloadVendorTemplateApi = async () => {
  try {
    return await get("template_download", { type: "Vendor" });
  } catch (err) {
    console.error("Error downloading template:", err);
    return err.response;
  }
};

export const uploadVendorExcelApi = async (body) => {
  try {
    return await post("vendor_upload", body);
  } catch (err) {
    console.error("Error uploading vendor:", err);
    return err.response;
  }
};
